import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DeleteModal} from "components";
import {MainInfo} from "fragments";
import {AddFacility} from "./fragments";
import {emptyState, facilitiesBody, facilitiesHead} from "./constants";
import {FacilitySingle} from "./facilitySingle";
import {facilitiesActions, httpRequestsOnSuccessActions} from "store";
import {FindSuccess, limit, useModal} from "utils";

const ACTION_TYPE = "GET_FACILITIES";
const ACTION_DELETE = "DELETE_FACILITIES";
const ACTION_CHANGE_STATUS = "CHANGE_STATUS_FACILITIES";

export const Facilities = () => {
    const facilitiesList = useSelector(
        (state) => state.facilities?.facilitiesList,
    );
    const dispatch = useDispatch();
    const location = useLocation();
    const {openModal, close} = useModal();
    const successChangeStatus = FindSuccess(ACTION_CHANGE_STATUS);
    const info = location?.state;


    const getFacilities = (noLoad) => {
        const params = {
            ...info,
        };
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = limit;

        dispatch(facilitiesActions.getFacilities(params, noLoad));
    }

    useEffect(() => {
        getFacilities();
    }, [info]);

    useEffect(() => {
        if (successChangeStatus?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_CHANGE_STATUS))
            getFacilities(true)
        }
    }, [successChangeStatus])

    const addFacility = (item) => {
        openModal(
            <AddFacility
                info={item}
                afterSuccess={() => getFacilities(true)}
                onCancel={close}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 610
            });
    };

    const handleDelete = (item) => {
        openModal(
            <DeleteModal
                handleDelete={() => {
                    dispatch(facilitiesActions.deleteFacility(item?.id));
                }}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.name} ?`}
                afterSuccess={() => {
                    getFacilities(true);
                    close();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleClickRow = (item) => {
        openModal(<FacilitySingle item={item} afterSuccess={() => getFacilities(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276
        });
    };

    return (
        <div className="facilities-page-wrapper">
            <MainInfo
                buttonText="Add Facilities"
                headerTable={facilitiesHead()}
                bodyTable={facilitiesBody({
                    handleDelete,
                    handleEit: (item) => addFacility(item),
                })}
                clickToAddButton={() => addFacility()}
                listTable={facilitiesList?.facilities}
                listCountTable={facilitiesList?.count}
                actionType={ACTION_TYPE}
                handleClickRow={handleClickRow}
                emptyState={emptyState(addFacility)}
            />
        </div>
    );
};
